"use strict";
'use client';
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useMenuItem = useMenuItem;
var React = _interopRequireWildcard(require("react"));
var _utils = require("@mui/utils");
var _useButton = require("../useButton");
var _useList = require("../useList");
var _useDropdown = require("../useDropdown");
var _DropdownContext = require("../useDropdown/DropdownContext");
var _combineHooksSlotProps = require("../utils/combineHooksSlotProps");
var _useCompound = require("../useCompound");
var _extractEventHandlers = require("../utils/extractEventHandlers");
function idGenerator(existingKeys) {
    return "menu-item-".concat(existingKeys.size);
}
var FALLBACK_MENU_CONTEXT = {
    dispatch: function() {},
    popupId: '',
    registerPopup: function() {},
    registerTrigger: function() {},
    state: {
        open: true,
        changeReason: null
    },
    triggerElement: null
};
/**
 *
 * Demos:
 *
 * - [Menu](https://mui.com/base-ui/react-menu/#hooks)
 *
 * API:
 *
 * - [useMenuItem API](https://mui.com/base-ui/react-menu/hooks-api/#use-menu-item)
 */ function useMenuItem(params) {
    var _params_disabled = params.disabled, disabled = _params_disabled === void 0 ? false : _params_disabled, idParam = params.id, externalRef = params.rootRef, label = params.label, _params_disableFocusOnHover = params.disableFocusOnHover, disableFocusOnHover = _params_disableFocusOnHover === void 0 ? false : _params_disableFocusOnHover;
    var id = (0, _utils.unstable_useId)(idParam);
    var itemRef = React.useRef(null);
    var itemMetadata = React.useMemo(function() {
        return {
            disabled: disabled,
            id: id !== null && id !== void 0 ? id : '',
            label: label,
            ref: itemRef
        };
    }, [
        disabled,
        id,
        label
    ]);
    var _React_useContext;
    var dispatch = ((_React_useContext = React.useContext(_DropdownContext.DropdownContext)) !== null && _React_useContext !== void 0 ? _React_useContext : FALLBACK_MENU_CONTEXT).dispatch;
    var _ref = (0, _useList.useListItem)({
        item: id,
        handlePointerOverEvents: !disableFocusOnHover
    }), getListRootProps = _ref.getRootProps, highlighted = _ref.highlighted;
    var _ref1 = (0, _useCompound.useCompoundItem)(id !== null && id !== void 0 ? id : idGenerator, itemMetadata), index = _ref1.index, totalItemCount = _ref1.totalItemCount;
    var _ref2 = (0, _useButton.useButton)({
        disabled: disabled,
        focusableWhenDisabled: true
    }), getButtonProps = _ref2.getRootProps, focusVisible = _ref2.focusVisible, buttonRefHandler = _ref2.rootRef;
    var handleRef = (0, _utils.unstable_useForkRef)(buttonRefHandler, externalRef, itemRef);
    React.useDebugValue({
        id: id,
        highlighted: highlighted,
        disabled: disabled,
        label: label
    });
    var createHandleClick = function(otherHandlers) {
        return function(event) {
            var _otherHandlers_onClick;
            (_otherHandlers_onClick = otherHandlers.onClick) === null || _otherHandlers_onClick === void 0 ? void 0 : _otherHandlers_onClick.call(otherHandlers, event);
            if (event.defaultMuiPrevented) {
                return;
            }
            dispatch({
                type: _useDropdown.DropdownActionTypes.close,
                event: event
            });
        };
    };
    var getOwnHandlers = function() {
        var otherHandlers = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return _object_spread_props(_object_spread({}, otherHandlers), {
            onClick: createHandleClick(otherHandlers)
        });
    };
    function getRootProps() {
        var externalProps = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var externalEventHandlers = (0, _extractEventHandlers.extractEventHandlers)(externalProps);
        var getCombinedRootProps = (0, _combineHooksSlotProps.combineHooksSlotProps)(getOwnHandlers, (0, _combineHooksSlotProps.combineHooksSlotProps)(getButtonProps, getListRootProps));
        return _object_spread_props(_object_spread({}, externalProps, externalEventHandlers, getCombinedRootProps(externalEventHandlers)), {
            id: id,
            ref: handleRef,
            role: 'menuitem'
        });
    }
    // If `id` is undefined (during SSR in React < 18), we fall back to rendering a simplified menu item
    // which does not have access to infortmation about its position or highlighted state.
    if (id === undefined) {
        return {
            getRootProps: getRootProps,
            disabled: false,
            focusVisible: focusVisible,
            highlighted: false,
            index: -1,
            totalItemCount: 0,
            rootRef: handleRef
        };
    }
    return {
        getRootProps: getRootProps,
        disabled: disabled,
        focusVisible: focusVisible,
        highlighted: highlighted,
        index: index,
        totalItemCount: totalItemCount,
        rootRef: handleRef
    };
}
